import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import Typography from "@/Utility/Typography";

const ProjectStatistics = ({ dataValues: dataValuesProp }) => {
  const dataValues = Array.isArray(dataValuesProp) ? dataValuesProp : [];
  const hasData = dataValues.length > 0;
  const maxValue = Math.max(...dataValues.map((d) => d.value), 1);
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  useEffect(() => {
    if (!canvasRef.current) return;
    if (!hasData) return;

    const existingChart = Chart.getChart(canvasRef.current);
    if (existingChart) {
      existingChart.destroy();
    }

    chartRef.current = new Chart(canvasRef.current, {
      type: "bar",
      data: {
        labels: dataValues.map((d) => d.name),
        datasets: [
          {
            label: "Severity",
            data: dataValues.map((d) => d.value),
            backgroundColor: dataValues.map((d) => d.color),
            borderRadius: 0,
            barPercentage: 0.4,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: true },
        },
        scales: {
          y: {
            beginAtZero: true,
            max: maxValue,
            grid: { drawBorder: false },
          },
        },
      },
    });

    return () => chartRef.current?.destroy();
  }, [dataValues, hasData]);

  if (!hasData) {
    return (
      <div className="py-10 text-center">
        <Typography variant="text2" className="text-gray-500">
          No data
        </Typography>
      </div>
    );
  }

  return (
    <div style={{ width: "100%", height: 300 }}>
      <canvas ref={canvasRef} />
    </div>
  );
};

export default ProjectStatistics;
